<template>
  <div id="CustomerService">
    <div v-if="contact === undefined" class="content empty">
      <inline-loading />
    </div>
    <div v-else :class="{ component: component }">
      <p v-if="!course_id && !order_id" class="guide">根据您的课程，添加对应的小管家</p>
      <div class="cs__item">
        <div v-for="item in contact" :key="item.cs_id" class="wechat">
          <img :src="item.qr_url" />
          <h2>{{ item.desc }}</h2>
          <h3 v-if="$store.state.isWechat">长按添加微信</h3>
          <h3 v-else>截图后在微信内扫一扫添加</h3>
          <a :href="'tel:' + item.phone" class="call">
            <i class="anyteachicon anyteach-call" />
            <span>致电咨询</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerService",
  props: {
    component: {
      type: Boolean,
      default: false,
    },
    course_id: {
      type: String,
      default: null
    },
    order_id: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      contact: null,
      isLoading: true,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const config = {
        course_id: this.course_id,
        order_id: this.order_id
      }
      const data = await this.$api.user.COURSE_CS(config)
      this.contact = data
      this.isLoading = false
    },
  },
}
</script>

<style scoped lang="scss">
#CustomerService {
  .empty {
    height: 200px;
  }

  .guide {
    font-size: 0.9rem;
  }
  .cs__item {
    padding: 10px 0 0px 0;
    clear: both;
    h1 {
      font-size: 0.8125rem;
      @include avenir-demi();
      line-height: 1.5;
      margin: 10px 0 5px 0;
    }
    h2,
    a {
      font-size: 1rem;
      font-weight: 400;
      line-height: 1;
      display: block;
    }
    h3 {
      font-size: 0.8125rem;
      font-weight: 400;
      opacity: 0.6;
    }
    h4 {
      font-size: 0.8125rem;
      @include avenir-demi();
    }
    a {
      display: inline-block;
      @include avenir-demi();
      padding: 0 0 3px 0;
      color: $blue;
    }
    .call {
      padding: 0;
      color: $blue;
      width: 100%;
      margin: 8px 0 0 0;
      border-top: 1px solid #eee;
      padding: 10px;
      display: inline-block;
      font-size: 0.8125rem;
      @include avenir-demi();
      i {
        font-weight: 400;
        margin-right: 3px;
      }
      &:active,
      &:hover {
        color: $blue !important;
      }
    }

    .wechat {
      border: 1px solid #eee;
      border-radius: 5px;
      padding: 10px 0;
      padding: 10px 0 0 0;
      text-align: center;
      margin: 0 0 10px 0;
      h2 {
        margin: 5px 0 0 0;
      }
      img {
        width: 100px;
      }
    }
  }
  .component {
    margin-top: 15px;
    .cs__item {
      border: 1px solid #eee;
      border-radius: 4px;
      padding: 0;
      h1 {
        margin: 0;
        padding: 5px 0;
      }
    }
    .wechat {
      margin: 0;
      border-top: 1px solid #eee;
      border-radius: 0;
    }
  }
}
</style>
